import React from 'react';
import { object, bool, func, string } from 'prop-types';

import { ButtonWrap } from './styles';
import { Title } from '../styled-components';
import { RequestInfo } from './request-info';
import { MeetingNoteInfo } from './meeting-note-info';
import { SpinnerWithBackground, ButtonWithLoader } from '../../components/ui-helpers/';

export const MeetingNotesModal = (props) => {
  const {
    form,
    date,
    text,
    meetingInfo,
    time,
    title,
    onSave,
    isLoading,
    meetingNote,
    onTextChange,
    onMeetingInfoChange,
    setMeetingDate,
    setMeetingTime,
  } = props;

  return (
    <React.Fragment>
      {isLoading && <SpinnerWithBackground />}

      <Title>{title}</Title>

      <RequestInfo request={meetingNote.request} />

      <form onSubmit={onSave}>
        <MeetingNoteInfo
          form={form}
          text={text}
          date={date}
          time={time}
          meetingInfo={meetingInfo}
          onTextChange={onTextChange}
          onMeetingInfoChange={onMeetingInfoChange}
          onDateChange={setMeetingDate}
          onTimeChange={setMeetingTime}
        />

        <ButtonWrap>
          <ButtonWithLoader type="submit">Save</ButtonWithLoader>
        </ButtonWrap>
      </form>
    </React.Fragment>
  );
};

MeetingNotesModal.propTypes = {
  date: object,
  time: object,
  form: object.isRequired,
  onSave: func.isRequired,
  text: string.isRequired,
  meetingInfo: string,
  title: string.isRequired,
  isLoading: bool.isRequired,
  onTextChange: func.isRequired,
  onMeetingInfoChange: func.isRequired,
  meetingNote: object.isRequired,
  setMeetingDate: func.isRequired,
  setMeetingTime: func.isRequired,
};

MeetingNotesModal.defaultProps = {
  date: null,
  time: null,
  meetingInfo: '',
};



// WEBPACK FOOTER //
// ./src/modals/meeting-notes-modal/component.js